import { Stack, Typography } from "@mui/material";
import { SvgContainer } from "../../../components";
import theme from "../../../theme/theme";

interface Props {
  title: string;
  value: string;
  icon: any;
}

function DashboardBottomHead({ title, value, icon }: Props) {
  return (
    <Stack direction={"row"} alignItems="center" justifyContent={'space-between'} mb={3}>
      <Stack direction={"row"} alignItems="center">
        <SvgContainer svg={icon} color={theme.colors.dimgray} />
        <Typography fontWeight={550} ml={1}>
          {title}
        </Typography>
      </Stack>
      <Stack
        sx={{
          backgroundColor: theme.colors.secondary,
          width: 24,
          height: 24,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 100
        }}
      >
        <Typography color="white" fontWeight={550} fontSize={13}>{value}</Typography>
      </Stack>
    </Stack>
  );
}

export default DashboardBottomHead;
